<template>
    <div>
        <preview-section-factory
            v-for="registrationData,index in registeredSections"
            :key = "registrationData.tempId ?  registrationData.tempId : registrationData.sectionId"
            :registrationData="registrationData"
        ></preview-section-factory>
    </div>
</template>

<script>
    import SectionsManager from '../../components/pagesbuilder/sections/SectionsManager.vue';
    import PreviewSectionFactory from './PreviewSectionFactory.vue';

    export default {
        name: "PreviewSectionsManager",
        mixins: [SectionsManager],
        methods: {
            sectionsWrapperParsedCallback () {
                // let linksReader = new linksManagerReader("pagesNew", this.sectionManagerWrapper);
                // linksReader.init();
            }
        },
        components: {
            PreviewSectionFactory
        },
    }
</script>
